<template>
  <div>
    <div class="search-box">
      <div class="tabs">
        <el-row>
          <el-col :span="2"><span class="title">填报模式></span></el-col>
          <el-col :span="21">
            <span v-for="(item, key) in piciLIst" :class="{ item: true, act: check.pici === item }" :key="key"
              @click="choose(item)">{{ item }}</span>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="specialty-search tianbao-search" v-if="check.nav != 2">
      <span class="span-name">院校名称：</span>
      <el-input placeholder="请输入院校名称" style="width:210px;margin-right:20px" v-model="check.name" size="mini"
        @keyup.enter.native="doSearch">
      </el-input>
    </div>
  </div>
</template>

<script>
// import cityList from "@/assets/data/city_data";
export default {
  name: "",
  props: {
    value: Object,
    new_batch: Number,
    piciLIst: Array
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {
    this.check = this.value
  },

  methods: {
    //选择条件
    choose(val) {
      this.check.pici = val
      this.$emit("onSearch", this.check);
    },
    doSearch() {
      this.$emit("onSearch", this.check);
    },
  },
};
</script>

<style scoped lang='less'>
.old_search {
  border: 1px solid #f3f3f3;
  background: #f3f3f3;
  padding: 3px 7px;
  border-radius: 10px;
  font-size: 12px;
  margin-right: 10px;
}

.search-box {
  margin: 0 0 20px;
  position: relative;

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .tabs {
    color: #666666;
    letter-spacing: 2px;
    padding: 3px 0 0 0;
    margin-bottom: 15px;
    font-size: 16px;
    position: relative;

    .title {
      color: #333333;
      font-weight: 500;
      text-align: center;
    }

    span {
      display: inline-block;
      padding: 0 6px;
      line-height: 26px;
      margin-bottom: 3px;
      margin-right: 6px;

      &:hover {
        background: #2B7BF3;
        color: white;
      }
    }
  }

  .act {
    background-color: #2B7BF3;
    color: #ffffff;
  }

  .act1 {
    background-color: #bd01ad;
    color: #ffffff;
  }

  .acts {
    background-color: #00e9ff30;
  }
}

.search-line {
  margin: 7px 0;
}

.tianbao-search {
  font-size: 16px;
  padding: 0 6px;

  .span-name {
    color: #A7A7A7;
    margin-right: 15px;
    position: relative;
    top: 4px;
  }
}
</style>

<style lang="less" scoped>
.select {
  color: #3D3D3D;
  font-size: 18px;
  padding: 0 7px;
  font-size: 16px;

  .select-item {
    display: inline-block;
    margin-right: 38px;
    margin-bottom: 10px;
  }

  .select-item-last {
    margin-right: 0px;
    float: right;
  }
}
</style>
